export default {"src":"/_next/static/media/snx.9b753468.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};